import { Edge } from '@/types';
import React from 'react';

export type EdgeCapacitiesTableProps = {
  edge: Edge;
  className?: string;
};

export const EdgeCapacitiesTable: React.FC<EdgeCapacitiesTableProps> = ({
  edge,
  className,
}) => {
  return (
    <table className={`table table-bordered mt-2 ${className}`}>
      <thead>
        <tr>
          <th className="text-center" colSpan={2}>
            Constrained By
          </th>
        </tr>
        <tr>
          <th>Component</th>
          <th>Direction</th>
        </tr>
      </thead>
      <tbody>
        {edge?.backhaul_capacity_components?.length > 0 ||
        edge?.forwardhaul_capacity_components?.length > 0 ? (
          <>
            {edge?.forwardhaul_capacity_components.map(
              ([componentId, componentDescription]) => (
                <tr key={componentId}>
                  <td>
                    <strong>#{componentId}</strong> {componentDescription}
                  </td>
                  <td>Forwardhaul</td>
                </tr>
              ),
            )}
            {edge?.backhaul_capacity_components.map(
              ([componentId, componentDescription]) => (
                <tr key={componentId}>
                  <td>
                    <strong>#{componentId}</strong> {componentDescription}
                  </td>
                  <td>Backhaul</td>
                </tr>
              ),
            )}
          </>
        ) : (
          <tr>
            <td colSpan={2} className="text-center">
              <em>No components</em>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
